import { render, staticRenderFns } from "./downsell-tip.vue?vue&type=template&id=208e9c74"
import script from "./downsell-tip.vue?vue&type=script&lang=js"
export * from "./downsell-tip.vue?vue&type=script&lang=js"
import style0 from "./downsell-tip.vue?vue&type=style&index=0&id=208e9c74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports